import { getLocale } from "../runtime";

const sv_iconlanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Språk`
};

const iconlanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconlanguage(inputs)
	return "iconLanguage";
};

export { iconlanguage as "iconLanguage" };